import React from "react";

import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";

import reportWebVitals from "./reportWebVitals";
import {
  GOOGLE_CLIENT_ID,
} from "../src/api/config";

import {
  GoogleOAuthProvider,
} from "@react-oauth/google";

const root = ReactDOM.createRoot(
  document.getElementById("root"),
);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider
      clientId={"218953107252-avt1ve808gnbqubuve4fnfedmi7jflpc.apps.googleusercontent.com"}
    >
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

reportWebVitals();